module.exports = __webpack_public_path__ + "static/img/prod_pic14.986d215.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prod_pic14.jpg
// module id = VlHD
// module chunks = 5